var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 122,
    height: 122.087,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198,
    height: 198,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(38 42.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 55.216,
    height: 120.425,
    transform: "translate(53.389)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 55.216,
    height: 120.425,
    transform: "translate(66.784)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 50.474,
    height: 7.283,
    transform: "translate(69.155 6.013)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 48.272,
    height: 5.081,
    transform: "translate(70.256 7.114)",
    fill: "#33afca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 8.021)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 10.053)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 8.021)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 10.053)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 23.628,
    height: 2.509,
    transform: "translate(93.531 8.4)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M991.538,105.719a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -97.081)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M1015.571,105.719a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -97.081)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M1039.6,105.719a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -97.081)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M1063.638,105.719a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -97.081)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M1087.672,105.719a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -97.081)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M991.538,131.937a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -121.266)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M1015.571,131.937a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -121.266)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M1039.6,131.937a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -121.266)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M1063.638,131.937a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -121.266)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M1087.672,131.937a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -121.266)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M1135.41,109.59c0,.694-.834,1.256-1.863,1.256s-1.863-.562-1.863-1.256.834-1.256,1.863-1.256,1.863.562,1.863,1.256",
    transform: "translate(-1043.954 -99.936)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 14.651)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 16.556)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 18.462)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 14.651)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 16.556)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 18.462)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 14.651)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 16.556)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 18.462)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 14.651)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 16.556)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 18.462)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 14.651)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 16.556)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 18.462)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 14.651)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 16.556)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 18.462)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 14.651)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 16.556)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 18.462)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 15.39)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 16.367)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 17.344)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 18.321)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 15.39)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 16.367)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 17.344)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 18.321)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 15.39)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 16.367)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 17.344)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 18.321)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 15.39)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 16.367)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 17.344)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 18.321)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M1195.183,193.569h-8.807a.89.89,0,0,1-.889-.889v-3.345a.89.89,0,0,1,.889-.889h8.807a.89.89,0,0,1,.889.889v3.345a.89.89,0,0,1-.889.889m-8.807-5.039a.806.806,0,0,0-.8.8v3.345a.806.806,0,0,0,.8.8h8.807a.805.805,0,0,0,.8-.8v-3.345a.805.805,0,0,0-.8-.8Z",
    transform: "translate(-1093.585 -173.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 50.474,
    height: 7.283,
    transform: "translate(69.155 21.299)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 48.272,
    height: 5.081,
    transform: "translate(70.256 22.4)",
    fill: "#33afca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 23.307)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 25.339)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 23.307)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 25.339)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 23.628,
    height: 2.509,
    transform: "translate(93.531 23.686)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M991.538,302.9a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -278.979)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M1015.571,302.9a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -278.979)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M1039.6,302.9a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -278.979)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M1063.638,302.9a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -278.979)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M1087.672,302.9a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -278.979)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M991.538,329.121a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -303.164)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M1015.571,329.121a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -303.164)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M1039.6,329.121a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -303.164)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M1063.638,329.121a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -303.164)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M1087.672,329.121a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -303.164)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1135.41,306.773c0,.694-.834,1.256-1.863,1.256s-1.863-.562-1.863-1.256.834-1.256,1.863-1.256,1.863.562,1.863,1.256",
    transform: "translate(-1043.954 -281.833)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 29.937)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 31.842)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 33.748)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 29.937)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 31.842)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 33.748)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 29.937)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 31.842)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 33.748)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 29.937)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 31.842)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 33.748)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 29.937)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 31.842)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 33.748)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 29.937)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 31.842)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 33.748)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 29.937)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 31.842)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 33.748)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 30.677)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 31.653)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 32.63)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 33.607)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 30.677)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 31.653)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 32.63)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 33.607)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 30.677)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 31.653)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 32.63)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 33.607)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 30.677)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 31.653)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 32.63)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 33.607)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1195.183,390.754h-8.807a.89.89,0,0,1-.889-.889v-3.345a.89.89,0,0,1,.889-.889h8.807a.89.89,0,0,1,.889.889v3.345a.89.89,0,0,1-.889.889m-8.807-5.039a.806.806,0,0,0-.8.8v3.345a.806.806,0,0,0,.8.8h8.807a.805.805,0,0,0,.8-.8v-3.345a.805.805,0,0,0-.8-.8Z",
    transform: "translate(-1093.585 -355.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 50.474,
    height: 7.283,
    transform: "translate(69.155 45.223)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 48.272,
    height: 5.081,
    transform: "translate(70.256 46.324)",
    fill: "#33afca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 47.231)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 49.263)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 47.231)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 49.263)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    width: 23.628,
    height: 2.509,
    transform: "translate(93.531 47.61)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M991.538,611.515a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -563.667)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M1015.571,611.515a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -563.667)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M1039.6,611.515a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -563.667)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M1063.638,611.515a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -563.667)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M1087.672,611.515a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -563.667)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M991.538,637.734a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -587.853)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M1015.571,637.734a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -587.853)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M1039.6,637.734a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -587.853)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M1063.638,637.734a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -587.853)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M1087.672,637.734a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -587.853)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M1135.41,615.387c0,.694-.834,1.256-1.863,1.256s-1.863-.562-1.863-1.256.834-1.256,1.863-1.256,1.863.562,1.863,1.256",
    transform: "translate(-1043.954 -566.523)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 53.861)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 55.767)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 57.672)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 53.861)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 55.767)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 57.672)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 53.861)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 55.767)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 57.672)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 53.861)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 55.767)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 57.672)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 53.861)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 55.767)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 57.672)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 53.861)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 55.767)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 57.672)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 53.861)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 55.767)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 57.672)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 54.601)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 55.577)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 56.554)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 57.531)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 54.601)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 55.577)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 56.554)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 57.531)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 54.601)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 55.577)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 56.554)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 57.531)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 54.601)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 55.577)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 56.554)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 57.531)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M1195.183,699.366h-8.807a.89.89,0,0,1-.889-.889v-3.345a.89.89,0,0,1,.889-.889h8.807a.89.89,0,0,1,.889.889v3.345a.89.89,0,0,1-.889.889m-8.807-5.039a.806.806,0,0,0-.8.8v3.345a.806.806,0,0,0,.8.8h8.807a.805.805,0,0,0,.8-.8v-3.345a.805.805,0,0,0-.8-.8Z",
    transform: "translate(-1093.585 -640.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 50.474,
    height: 7.283,
    transform: "translate(69.155 60.509)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 48.272,
    height: 5.081,
    transform: "translate(70.256 61.61)",
    fill: "#33afca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 62.517)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 64.549)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 62.517)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 64.549)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 23.628,
    height: 2.509,
    transform: "translate(93.531 62.896)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M991.538,808.7a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -745.565)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M1015.571,808.7a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -745.565)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M1039.6,808.7a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -745.565)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M1063.638,808.7a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -745.565)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M1087.672,808.7a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -745.565)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M991.538,834.918a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -769.751)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M1015.571,834.918a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -769.751)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M1039.6,834.918a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -769.751)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M1063.638,834.918a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -769.751)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M1087.672,834.918a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -769.751)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M1135.41,812.57c0,.694-.834,1.256-1.863,1.256s-1.863-.562-1.863-1.256.834-1.256,1.863-1.256,1.863.562,1.863,1.256",
    transform: "translate(-1043.954 -748.42)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 69.147)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 71.053)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 72.958)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 69.147)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 71.053)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 72.958)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 69.147)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 71.053)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 72.958)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 69.147)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 71.053)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 72.958)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 69.147)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 71.053)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 72.958)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 69.147)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 71.053)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 72.958)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 69.147)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 71.053)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 72.958)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 69.887)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 70.863)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 71.84)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 72.817)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 69.887)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 70.863)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 71.84)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 72.817)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 69.887)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 70.863)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 71.84)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 72.817)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 69.887)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 70.863)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 71.84)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 72.817)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M1195.183,896.551h-8.807a.89.89,0,0,1-.889-.889v-3.345a.89.89,0,0,1,.889-.889h8.807a.89.89,0,0,1,.889.889v3.345a.89.89,0,0,1-.889.889m-8.807-5.039a.806.806,0,0,0-.8.8v3.345a.806.806,0,0,0,.8.8h8.807a.805.805,0,0,0,.8-.8v-3.345a.805.805,0,0,0-.8-.8Z",
    transform: "translate(-1093.585 -822.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 50.474,
    height: 7.283,
    transform: "translate(69.155 84.433)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 48.272,
    height: 5.081,
    transform: "translate(70.256 85.534)",
    fill: "#33afca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 86.441)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 88.473)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 86.441)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 88.473)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 23.628,
    height: 2.509,
    transform: "translate(93.531 86.82)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M991.538,1117.312a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -1030.253)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M1015.571,1117.312a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -1030.253)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M1039.6,1117.312a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -1030.253)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M1063.638,1117.312a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -1030.253)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M1087.672,1117.312a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -1030.253)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M991.538,1143.531a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -1054.44)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M1015.571,1143.531a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -1054.44)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M1039.6,1143.531a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -1054.44)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M1063.638,1143.531a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -1054.44)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M1087.672,1143.531a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -1054.44)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M1135.41,1121.183c0,.694-.834,1.256-1.863,1.256s-1.863-.562-1.863-1.256.834-1.256,1.863-1.256,1.863.562,1.863,1.256",
    transform: "translate(-1043.954 -1033.108)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 93.071)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 94.977)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 96.882)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 93.071)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 94.977)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 96.882)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 93.071)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 94.977)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 96.882)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 93.071)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 94.977)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 96.882)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 93.071)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 94.977)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 96.882)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 93.071)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 94.977)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 96.882)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 93.071)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 94.977)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 96.882)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 93.811)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 94.788)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 95.764)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 96.741)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 93.811)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 94.788)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 95.764)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 96.741)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 93.811)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 94.788)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 95.764)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 96.741)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 93.811)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 94.788)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 95.764)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 96.741)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M1195.183,1205.163h-8.807a.89.89,0,0,1-.889-.889v-3.345a.89.89,0,0,1,.889-.889h8.807a.89.89,0,0,1,.889.889v3.345a.89.89,0,0,1-.889.889m-8.807-5.039a.806.806,0,0,0-.8.8v3.345a.805.805,0,0,0,.8.8h8.807a.805.805,0,0,0,.8-.8v-3.345a.805.805,0,0,0-.8-.8Z",
    transform: "translate(-1093.585 -1107.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 50.474,
    height: 7.283,
    transform: "translate(69.155 99.809)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 48.272,
    height: 5.081,
    transform: "translate(70.256 100.91)",
    fill: "#33afca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 101.817)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 1.715,
    height: 1.235,
    transform: "translate(71.343 103.849)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 101.817)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 1.715,
    height: 1.235,
    transform: "translate(73.972 103.849)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 23.628,
    height: 2.509,
    transform: "translate(93.531 102.196)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M991.538,1315.657a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -1213.222)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M1015.571,1315.657a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -1213.222)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M1039.6,1315.657a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -1213.222)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M1063.638,1315.657a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -1213.222)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M1087.672,1315.657a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -1213.222)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M991.538,1341.876a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-913.787 -1237.409)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M1015.571,1341.876a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-935.957 -1237.409)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M1039.6,1341.876a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-958.128 -1237.409)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M1063.638,1341.876a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-980.297 -1237.409)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M1087.672,1341.876a.48.48,0,1,1-.48-.48.48.48,0,0,1,.48.48",
    transform: "translate(-1002.468 -1237.409)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M1135.41,1319.529c0,.694-.834,1.256-1.863,1.256s-1.863-.562-1.863-1.256.834-1.256,1.863-1.256,1.863.562,1.863,1.256",
    transform: "translate(-1043.954 -1216.078)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 108.447)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 110.353)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 4.192,
    height: 1.228,
    transform: "translate(69.155 112.258)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 108.447)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 110.353)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 4.192,
    height: 1.228,
    transform: "translate(74.462 112.258)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 108.447)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 110.353)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 4.192,
    height: 1.228,
    transform: "translate(79.769 112.258)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 108.447)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 110.353)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 4.192,
    height: 1.228,
    transform: "translate(85.076 112.258)",
    fill: "#009ee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 108.447)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 110.353)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 4.192,
    height: 1.228,
    transform: "translate(104.823 112.258)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 108.447)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 110.353)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 4.192,
    height: 1.228,
    transform: "translate(110.13 112.258)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 108.447)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 110.353)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 4.192,
    height: 1.228,
    transform: "translate(115.437 112.258)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 109.187)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 110.164)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 111.14)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 1.434,
    height: 0.629,
    transform: "translate(93.131 112.117)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 109.187)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 110.164)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 111.14)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 1.434,
    height: 0.629,
    transform: "translate(95.361 112.117)",
    fill: "#7dff97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 109.187)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 110.164)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 111.14)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 1.434,
    height: 0.629,
    transform: "translate(97.592 112.117)",
    fill: "#4c7dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 109.187)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 110.164)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 111.14)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 1.434,
    height: 0.629,
    transform: "translate(99.822 112.117)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M1195.183,1403.508h-8.807a.89.89,0,0,1-.889-.889v-3.345a.89.89,0,0,1,.889-.889h8.807a.89.89,0,0,1,.889.889v3.345a.89.89,0,0,1-.889.889m-8.807-5.039a.806.806,0,0,0-.8.8v3.345a.806.806,0,0,0,.8.8h8.807a.805.805,0,0,0,.8-.8v-3.345a.806.806,0,0,0-.8-.8Z",
    transform: "translate(-1093.585 -1289.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M892.25,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-822.248 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M898.539,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-828.127 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M915.555,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-843.747 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M921.845,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-849.627 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M938.861,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-865.246 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M945.15,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-871.125 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M962.166,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-886.744 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M968.455,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-892.623 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M985.471,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-908.243 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M991.761,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-914.123 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M1008.777,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-929.742 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M1015.066,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-935.621 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M1032.082,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-951.24 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M1038.371,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-957.119 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M1055.387,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-972.739 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M1061.676,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-978.618 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M1078.694,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-994.239 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M1084.982,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1000.117 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M1102,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1015.736 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M1108.287,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1021.615 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M1125.3,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1037.235 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M1131.592,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1043.114 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M1148.609,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1058.734 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M1154.9,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1064.612 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M1171.915,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1080.233 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M1178.2,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1086.111 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M1195.219,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1101.731 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M1201.508,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1107.61 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M1218.524,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1123.229 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M1224.813,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1129.108 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M1241.83,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1144.728 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M1248.119,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1150.607 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M1265.136,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1166.227 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M1271.423,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1172.106 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M1288.44,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1187.725 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M1294.729,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1193.604 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M1311.746,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1209.224 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M1318.035,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1215.103 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M1335.051,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1230.723 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M1341.34,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1236.602 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M1358.356,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1252.221 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M1364.645,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1258.1 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M1381.662,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1273.721 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M1387.95,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1279.599 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M1404.967,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1295.219 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M1411.256,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1301.098 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M1428.272,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1316.717 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M1434.561,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1322.596 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M1451.577,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1338.215 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M1457.866,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1344.094 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M1474.883,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1359.715 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M1481.172,23.532a.409.409,0,1,1-.41-.409.41.41,0,0,1,.41.409",
    transform: "translate(-1365.594 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M1498.188,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1381.213 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M1504.477,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1387.092 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M1521.494,16.751a.9.9,0,0,0-.9.9v2.2h1.807v-2.2a.9.9,0,0,0-.9-.9",
    transform: "translate(-1402.712 -15.452)",
    fill: "#c3c6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M1527.782,23.532a.409.409,0,1,1-.409-.409.409.409,0,0,1,.409.409",
    transform: "translate(-1408.59 -21.33)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    width: 50.53,
    height: 1.468,
    transform: "translate(69.099 38.787)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 50.53,
    height: 1.468,
    transform: "translate(69.099 78.621)",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M967.405,40.02a7.425,7.425,0,0,1-3.657-.948,7.122,7.122,0,0,1-3.431-6.746.381.381,0,1,1,.762.019,6.393,6.393,0,0,0,3.047,6.065,6.7,6.7,0,0,0,6.617-.071c2.3-1.441,2.229-5.329,2.176-8.454a11.12,11.12,0,0,1,.257-3.664,4.446,4.446,0,0,1,2.456-2.718.381.381,0,0,1,.228.727,3.745,3.745,0,0,0-1.978,2.279,11.53,11.53,0,0,0-.2,3.363c.054,3.141.127,7.443-2.532,9.113a7.061,7.061,0,0,1-3.742,1.036",
    transform: "translate(-885.869 -21.665)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M973.489,39.259c-2.9,0-6.171-3.681-8.379-6.167a16.1,16.1,0,0,0-1.786-1.857,3.012,3.012,0,0,0-2.474-.568.381.381,0,1,1-.234-.725,3.755,3.755,0,0,1,3.143.667,15.526,15.526,0,0,1,1.92,1.976c2.1,2.365,5.613,6.322,8.229,5.876,2.977-.509,3.219-3.9,3.433-6.895.039-.542.075-1.054.127-1.54.356-3.342,3.337-6.3,3.464-6.429a.381.381,0,0,1,.534.544c-.029.029-2.914,2.9-3.24,5.967-.051.473-.087.979-.125,1.514-.222,3.111-.5,6.982-4.065,7.592a3.255,3.255,0,0,1-.549.046",
    transform: "translate(-885.905 -21.667)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M481.519,573.846s10,1.553,10.295,3.133a3.962,3.962,0,0,1-1.289,3.529c-.791.875-7.486.243-8.864-.584s-.141-6.078-.141-6.078",
    transform: "translate(-443.72 -529.361)",
    fill: "#008cdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M66.818,1518.621c0,1.253-14.958,2.269-33.409,2.269S0,1519.874,0,1518.621s14.958-2.269,33.409-2.269,33.409,1.016,33.409,2.269",
    transform: "translate(0 -1398.802)",
    fill: "#a7c6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M403.391,1476.933s4.349,2.428,4.324,2.857c-.06,1.038-1.733,1.391-4.081,1.3a10.65,10.65,0,0,1-4.139-1.048l-.48-.5-.034.608-1.849-.485a6.728,6.728,0,0,1-.038-2.705,2.011,2.011,0,0,1,1.04-1.12c1.177-.4,3.1.019,5.259,1.1",
    transform: "translate(-366.194 -1361.286)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M407.956,1436.561s-.811-.268-1.141.063-1.591,1.168-1.748.85c-.5-1.024-.91-.922-.907-.979s-.438-2.757.387-2.954,3.1-1.106,3.254-.783-.008,3.718.154,3.8",
    transform: "translate(-372.724 -1321.626)",
    fill: "#41cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M72.093,1472.93s-4.581,2.633-4.538,3.672,2.043.965,4.367.544A11.689,11.689,0,0,0,76,1475.519l.467-.573.044.608,1.823-.744a6.968,6.968,0,0,0-.008-2.73,1.7,1.7,0,0,0-1.049-.985c-1.172-.237-3.074.447-5.19,1.835",
    transform: "translate(-62.318 -1357.011)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M151.042,1440.7s.8-.382,1.131-.094,1.6.957,1.745.615c.483-1.1.886-1.054.882-1.111s.388-2.838-.433-2.922a4.6,4.6,0,0,0-2.763.872c-.143.346-.4,2.532-.562,2.64",
    transform: "translate(-139.333 -1325.769)",
    fill: "#41cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M138.083,710.431l-3.445,25.015-1.524,11.195-.645,9.558-2.4,12.967a5.152,5.152,0,0,0,3.189.648c.853-.05,5.02-.976,5.02-.976s8.11-43.522,9.607-47.862c.038,2.089.212,12.419.428,22.982.254,12.442.551,25.207.551,25.207H155.5l1.745-22.525.137-10.2.884-25.313-9.335-.322Z",
    transform: "translate(-119.987 -655.357)",
    fill: "#3373a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M376.644,916.742h0a.085.085,0,0,1-.081-.088c0-.079.339-7.958.339-8.6,0-.191-.034-1.573-.081-3.486-.111-4.516-.3-12.073-.258-13.1.032-.836-.259-3.808-.493-6.2-.2-2.037-.321-3.3-.3-3.508.055-.5,0-10.315,0-10.414a.085.085,0,0,1,.084-.085h0a.085.085,0,0,1,.085.084c0,.405.058,9.927,0,10.434-.023.206.133,1.793.3,3.473.235,2.394.526,5.373.494,6.22-.04,1.025.146,8.579.258,13.093.047,1.914.081,3.3.081,3.49,0,.648-.325,8.285-.339,8.61a.085.085,0,0,1-.085.081",
    transform: "translate(-346.636 -803.716)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M265.742,751.45l.179-5.12-19.075,2.328s1.93,1.923,8.536,2.685a50.37,50.37,0,0,0,10.36.107",
    transform: "translate(-227.71 -688.473)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M233.636,306.523a4.576,4.576,0,0,1,3.5.9c4.042,3.191,5.036,8.062,6.319,15.391,1.748,9.983,1.783,15.891,1.247,19.25-.2,1.259-2.552,3.1-14.97,2.061-3.7-.31-6.285-1.289-6.851-3.162-.338-1.119.855-9.61,1.3-13.381.533-4.529,2.221-15.291,5.883-19.326a7.255,7.255,0,0,1,3.576-1.736",
    transform: "translate(-205.546 -282.733)",
    fill: "#00b4ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M357.639,307.368a.694.694,0,0,0-.514.617c-.088.543,1.645,4.241,3.444,4.431s.921-3.926.062-4.408a10.2,10.2,0,0,0-2.992-.641",
    transform: "translate(-329.437 -283.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M369.933,189.44s-1.109,4.225.488,4.988c1.734.828,1.907-3.453,1.722-3.913s-1.81-1.378-2.211-1.075",
    transform: "translate(-340.909 -174.699)",
    fill: "#526f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M365.364,263.737a12.322,12.322,0,0,1-1.255,2.983c-.406.566,1.412,2.2,2.474,2.432s.526-1.839.5-2.356.185-1.97.151-2.2-1.517-1.1-1.872-.862",
    transform: "translate(-335.829 -243.254)",
    fill: "#41cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M378.972,219.615s-.153-.053-.234,0-.1.346-.05.356.24-.157.337-.155-.053-.2-.053-.2",
    transform: "translate(-349.309 -202.567)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M384.3,275.743l1.524,1.167a8.819,8.819,0,0,0-.059,1c.005.111.034.292.065.507a1.981,1.981,0,0,1-.518-.212c-1.03-.684-1.012-2.461-1.012-2.461",
    transform: "translate(-354.505 -254.367)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M378.837,205.59l-.3,2.352a11.6,11.6,0,0,1-.247,1.908c-.209.8-.826,2.309-2.339,2.086s-2.778-1.29-2.9-2.183a6.926,6.926,0,0,1-.041-1.589s-.47-.061-.572-.712-.179-1.5.373-1.455.593.357.727.348.945-1.56,1.668-1.6,3.4-.011,3.638.843",
    transform: "translate(-343.494 -188.865)",
    fill: "#41cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M413.678,225.888a.084.084,0,0,1-.06-.025c-.016-.016-.369-.349-1.226-.1a.085.085,0,0,1-.047-.163c.964-.28,1.377.126,1.394.144a.085.085,0,0,1-.06.144",
    transform: "translate(-380.323 -208.021)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M406.435,244.086c-.05.178.184.4.523.495s.654.027.7-.151-.184-.4-.523-.495-.654-.027-.7.151",
    transform: "translate(-374.921 -224.985)",
    fill: "#00b4ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M443.072,251.9c-.05.178.1.378.343.445a.406.406,0,0,0,.524-.2c.05-.179-.1-.378-.343-.445a.406.406,0,0,0-.524.2",
    transform: "translate(-408.715 -232.169)",
    fill: "#00b4ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M414.638,234.206h-.01a5.51,5.51,0,0,1-.942-.188.085.085,0,0,1,.052-.161,5.455,5.455,0,0,0,.91.181.085.085,0,0,1-.01.169",
    transform: "translate(-381.563 -215.723)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M441.888,240.69h-.006a2.644,2.644,0,0,1-.817-.2.085.085,0,0,1,.07-.154,2.518,2.518,0,0,0,.759.182.085.085,0,0,1-.006.169",
    transform: "translate(-406.827 -221.701)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M383.734,204.139s-.037,1.258.355,1.431.82-1.415.96-1.7a2.081,2.081,0,0,1,.484-.566s-1.921-.589-1.8.837",
    transform: "translate(-353.982 -187.431)",
    fill: "#526f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M428.119,234.613a1.042,1.042,0,0,1-.487-.1.085.085,0,0,1,.088-.145,1.034,1.034,0,0,0,.47.072.336.336,0,0,0,.229-.162.757.757,0,0,0-.077-.579,1.011,1.011,0,0,1,.359-1.142c.342-.284.9.086.929.1a.085.085,0,0,1-.094.141c-.133-.089-.523-.282-.726-.112a.845.845,0,0,0-.31.947.883.883,0,0,1,.072.719.5.5,0,0,1-.346.253l-.016,0c-.011,0-.044,0-.09,0",
    transform: "translate(-394.444 -214.432)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M416.888,236.483s-.159.317-.012.463.271.048.341-.048.137-.355.036-.405-.317-.065-.365-.01",
    transform: "translate(-384.501 -218.118)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M443.1,242.961s-.156.318-.04.45.229.029.294-.068.14-.353.057-.4-.267-.043-.311.014",
    transform: "translate(-408.677 -224.085)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M292.069,832.542c-.281,0-.522,0-.7,0a.085.085,0,0,1,0-.169h0a31.93,31.93,0,0,0,4.525-.168,34.433,34.433,0,0,0-4.614-1.084.085.085,0,0,1,.031-.166c.012,0,1.175.223,2.334.477,2.391.523,2.435.666,2.462.752a.112.112,0,0,1-.029.114,17.809,17.809,0,0,1-4.014.249m3.887-.3h0Z",
    transform: "translate(-268.641 -766.533)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M365.882,839.64a.085.085,0,0,1-.008-.169c2.271-.215,4.682-.585,4.832-.835l0,0c-.315-.293-2.983.013-4.577.2a13.852,13.852,0,0,1-1.73.154.085.085,0,0,1,.024-.168,16.025,16.025,0,0,0,1.687-.155c2.374-.272,4.367-.472,4.711-.152a.16.16,0,0,1,.053.176c-.033.1-.112.33-2.579.674-1.2.167-2.389.281-2.4.282h-.008",
    transform: "translate(-336.079 -773.353)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M360.876,298.881l-.577.5-2.323-2.046s-.151-.267-.535.146a2.742,2.742,0,0,0-.273.581l1.483,2.859,1.56-.512.989.536a8.614,8.614,0,0,0,.1-1.51c-.005-.18-.427-.554-.427-.554",
    transform: "translate(-329.48 -274.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M380.811,175.161a1.714,1.714,0,0,1-1.471,1.128,16.558,16.558,0,0,1-2.137-.175c-.089-.011.384-.43.3-.442-.194-.026-.7.419-1.332.3a7.725,7.725,0,0,0-.835-.129l-1.179-.427s-.456-1.146-.516-1.417.408-.732.641-.867a7.448,7.448,0,0,1,3.155-.71c1.876-.142,3.973.379,3.376,2.74",
    transform: "translate(-344.669 -159.035)",
    fill: "#526f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M430.356,235.139a2.015,2.015,0,0,1,.583.073,1.072,1.072,0,0,1,.289.153l-.034.217s-.524-.273-.714-.214-.124-.228-.124-.228",
    transform: "translate(-396.984 -216.91)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M405.625,228.266a.854.854,0,0,1,.1.216,1.389,1.389,0,0,0-.017.652c.171.492.522.563.934.65.664.139.815-.166.877-.446s.25-.657.094-.923-.859-.33-1.018-.341a3.55,3.55,0,0,0-.856-.074c-.119.061-.119.266-.119.266m.437-.013a2.967,2.967,0,0,1,1.4.264c.217.218-.1.927-.152,1.013s-.26.223-.631.154-.965-.188-.781-1.1c0,0-.011-.312.168-.334",
    transform: "translate(-374.18 -210.309)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M438.915,237.466c.008.134-.3,1.15.223,1.461s.934.162,1.014.032.277-.886.322-.823.184.145.245-.006.153-.242.063-.284-.4-.18-.568-.261c-.369-.176-1.307-.253-1.3-.119m.286.064c.141-.015.942.047,1.083.269s-.192.9-.241.984a.438.438,0,0,1-.507.124c-.278-.083-.744-.148-.49-1.029,0,0,.014-.335.155-.349",
    transform: "translate(-404.813 -218.995)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M415.257,261.038a10.653,10.653,0,0,0,2.293.544s-.376.687-.708.7a2,2,0,0,1-1.28-.471,1.406,1.406,0,0,1-.3-.769",
    transform: "translate(-383.066 -240.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M384.643,220.669l-.095-.121-1.9-.643.053.2,1.838.785Z",
    transform: "translate(-352.984 -202.858)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M361.8,313.38h0c-.2,0-.687-.553-.934-.845-1.5.9-1.615.738-1.659.676-.119-.168-1.383-2.441-1.437-2.537a.085.085,0,0,1,.148-.082c.441.793,1.286,2.3,1.417,2.507a6.244,6.244,0,0,0,1.5-.746.085.085,0,0,1,.109.018,4.543,4.543,0,0,0,.834.834,4.3,4.3,0,0,0-.016-1.188.085.085,0,0,1,.168-.019c.038.348.112,1.174-.036,1.337a.131.131,0,0,1-.1.045",
    transform: "translate(-330.022 -286.474)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M173.684,325.764s-15.114,10.474-11.387,19.453,17.273,7.868,18.194,7.426c1.236-.594,2.339-4.123.991-5.054s-11.394-5.589-11.394-6.817,5.071-7.968,6.563-10.445c1.178-1.956.46-5.977-2.967-4.562",
    transform: "translate(-149.17 -300.238)",
    fill: "#00b4ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M388.992,628.47a10.3,10.3,0,0,0,2.043.233c.851-.028,1.179-.22,1.636.269s1.916,1.529,1.575,1.646-1.7-.842-1.7-.842,1.586,1.624,1.262,1.9-.5.113-.5.113.07.495-.124.538a9.137,9.137,0,0,1-1.662-1.035s.829,1.324.52,1.5-1.362-1.062-1.362-1.062a5.631,5.631,0,0,1-2.274-.672c-.683-.53-1.176-.846-.979-1.72a1.518,1.518,0,0,1,1.567-.866",
    transform: "translate(-357.35 -579.732)",
    fill: "#41cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M411.71,620.656s1.539-.232,2.027-.363c.646-.173.941-.534,1.229-.394.583.284-.325.755-.567.93a3.541,3.541,0,0,1-1.251.675c-.5.1-1.533-.635-1.438-.847",
    transform: "translate(-379.788 -571.815)",
    fill: "#41cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M239.831,651.827h0a36.076,36.076,0,0,1-4.3-.47,27.849,27.849,0,0,1-5.173-1.72.085.085,0,1,1,.069-.155,27.664,27.664,0,0,0,5.134,1.708,35.913,35.913,0,0,0,4.279.467.085.085,0,0,1,0,.169",
    transform: "translate(-212.449 -599.127)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 27.769,
    height: 7.565,
    transform: "translate(30.827 74.959)",
    fill: "#dce9ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 20.939,
    height: 7.565,
    transform: "translate(37.657 74.959)",
    fill: "#b1c1c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 18.579,
    height: 5.204,
    transform: "translate(38.837 76.139)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M398.078,360.753l26.306.067a.4.4,0,0,0,.424-.405l2.223-14.992a.452.452,0,0,0-.424-.446L400.3,344.91a.4.4,0,0,0-.424.405l-2.222,14.992a.452.452,0,0,0,.424.446",
    transform: "translate(-366.827 -318.172)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M517.02,636.544c0,.729,2.881,1.319,6.435,1.319s6.435-.591,6.435-1.319-2.881-1.32-6.435-1.32-6.435.591-6.435,1.32",
    transform: "translate(-476.94 -585.98)",
    fill: "#1a4c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M585.423,430.233l-3.187.18a.361.361,0,0,0-.336.415l1.881,12.544a5.673,5.673,0,0,1-.13,2.305l-.562,2.1,4.431-.2.26-1.95a9.523,9.523,0,0,0-.033-2.742L585.8,430.538a.36.36,0,0,0-.375-.3",
    transform: "translate(-536.787 -396.88)",
    fill: "#1a4c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M332.381,641.184h24.693a.339.339,0,0,1,.11.659l-9.054,3.1a8.4,8.4,0,0,1-2.722.453H320.266a.339.339,0,0,1-.1-.661l9.714-3.155a8.113,8.113,0,0,1,2.506-.4",
    transform: "translate(-295.126 -591.478)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 2.578,
    height: 62.605,
    transform: "translate(45.515 52.147)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M427.55,1453.484h3.409v1.992l12.831,2.245a1.158,1.158,0,0,1,.9,1.518l-14.173-2.347v1.64a.707.707,0,0,1-.707.707h-.933a.707.707,0,0,1-.707-.707v-1.6l-13.453,2.3-.022-.051a1.239,1.239,0,0,1,.877-1.7l11.938-2.01Z",
    transform: "translate(-382.449 -1340.808)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M413.868,1519.028a1.572,1.572,0,1,1-1.572-1.572,1.572,1.572,0,0,1,1.572,1.572",
    transform: "translate(-378.884 -1399.821)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M770.8,1519.028a1.572,1.572,0,1,1-1.572-1.572,1.572,1.572,0,0,1,1.572,1.572",
    transform: "translate(-708.146 -1399.821)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M593.876,1517.456h0a.9.9,0,0,0-.9.9v1.739a.9.9,0,1,0,1.8,0v-1.739a.9.9,0,0,0-.9-.9",
    transform: "translate(-547.006 -1399.821)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M371.474,1064.526H334.68a.363.363,0,0,0-.363.363v1.089a.363.363,0,0,0,.363.363h36.794a.363.363,0,0,0,.363-.363v-1.089a.363.363,0,0,0-.363-.363",
    transform: "translate(-308.4 -982.002)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 0.908,
    height: 0.908,
    transform: "translate(40.259 78.288)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 0.908,
    height: 0.908,
    transform: "translate(42.15 78.288)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 0.908,
    height: 0.908,
    transform: "translate(44.042 78.288)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M671.011,570.559h-3.086a.272.272,0,0,1,0-.545h3.086a1.5,1.5,0,0,0,1.5-1.5v-35.6a.636.636,0,0,0-.635-.635.272.272,0,1,1,0-.545,1.181,1.181,0,0,1,1.18,1.18v35.6a2.045,2.045,0,0,1-2.042,2.042",
    transform: "translate(-615.895 -490.516)",
    fill: "#00b4ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M630.9,580.694h-.787a2.242,2.242,0,0,1-2.239-2.239v-7.716a.757.757,0,0,0-.756-.757h-.182a.272.272,0,1,1,0-.545h.182a1.3,1.3,0,0,1,1.3,1.3v7.716a1.7,1.7,0,0,0,1.695,1.695h.787a1.7,1.7,0,0,0,1.694-1.695V533.037a.757.757,0,0,0-.756-.756h-.8a.272.272,0,1,1,0-.545h.8a1.3,1.3,0,0,1,1.3,1.3v45.418a2.242,2.242,0,0,1-2.239,2.239",
    transform: "translate(-578.088 -490.515)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M214.357,422.836a.085.085,0,0,1-.078-.117c.009-.023.219-.58-.5-1.232a9.355,9.355,0,0,0-2.194-1.18,14.92,14.92,0,0,1-1.531-.739c-1.682-1.008-6.406-3.805-6.754-3.9a8.226,8.226,0,0,0-1.344,1.316c-1.463,1.585-2.628,2.78-3.207,2.57a.248.248,0,0,1-.179-.206c-.069-.532,1.758-1.973,2.907-2.821a19.2,19.2,0,0,1-3.979,1.633.279.279,0,0,1-.085-.011.153.153,0,0,1-.094-.076.141.141,0,0,1-.005-.112c.1-.294,1.384-.922,3.33-1.846a16.715,16.715,0,0,0,2.209-1.14c.047-.095.107-.235.183-.414a15.33,15.33,0,0,1,.855-1.757c.551-.948,4.541-6.758,4.582-6.816a.085.085,0,1,1,.14.1c-.04.059-4.026,5.863-4.575,6.805a15.173,15.173,0,0,0-.845,1.738c-.077.181-.138.324-.189.425a9.99,9.99,0,0,1-2.287,1.215A18.975,18.975,0,0,0,197.48,418a23.493,23.493,0,0,0,4.869-2.1.085.085,0,0,1,.087.145c-1.464,1.018-3.763,2.81-3.7,3.283,0,.015.006.046.069.069.519.189,2.027-1.445,3.024-2.526.971-1.051,1.326-1.415,1.513-1.365.45.121,6.734,3.879,6.8,3.917a14.823,14.823,0,0,0,1.512.73,9.427,9.427,0,0,1,2.24,1.209c.815.736.557,1.394.546,1.422a.085.085,0,0,1-.078.053",
    transform: "translate(-182.006 -374.483)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M168.484,1310.948c-.161,0-.541-.219-1.735-2.323-.665-1.171-1.267-2.376-1.273-2.388a.085.085,0,1,1,.152-.076c.006.012.607,1.213,1.269,2.38,1.247,2.2,1.555,2.244,1.605,2.233,0,0,.069-.027.057-.352-.083-2.093-3.55-7.374-3.585-7.427a.085.085,0,0,1,.141-.093c.144.219,3.528,5.374,3.613,7.514.008.2,0,.476-.184.522a.223.223,0,0,1-.06.009",
    transform: "translate(-152.171 -1201.864)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M173.237,838.538h-.014a.085.085,0,0,1-.07-.1c.013-.083,1.351-8.342,1.165-9.543a20.908,20.908,0,0,1,.831-4.654,46.6,46.6,0,0,0,.969-4.769c.295-2.681,3.02-18.9,3.048-19.06a.085.085,0,0,1,.167.028c-.027.163-2.752,16.373-3.046,19.05a46.676,46.676,0,0,1-.973,4.789,21.19,21.19,0,0,0-.828,4.589c.19,1.227-1.11,9.255-1.165,9.6a.085.085,0,0,1-.083.071",
    transform: "translate(-159.73 -738.3)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M143.516,1371.273a.085.085,0,0,1-.085-.08,13.038,13.038,0,0,1,0-1.366c.042-.55,1.262-6.4,1.314-6.646a.085.085,0,0,1,.166.035c-.013.061-1.27,6.085-1.311,6.624a13.14,13.14,0,0,0,0,1.344.085.085,0,0,1-.08.089h0",
    transform: "translate(-132.295 -1257.443)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M699.709,867.207h-8.642a11.876,11.876,0,0,1-11.863-11.863v-5.123a.3.3,0,1,1,.593,0v5.123a11.283,11.283,0,0,0,11.27,11.27h8.642a11.283,11.283,0,0,0,11.27-11.27V837.1a.3.3,0,0,1,.593,0v18.244a11.876,11.876,0,0,1-11.863,11.863",
    transform: "translate(-626.552 -771.934)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerroom);
export default __webpack_public_path__ + "static/media/serverroom.afb73acb10c0950ed6c56a06e1e7d6f3.svg";
export { ForwardRef as ReactComponent };